/**
 * @file
 *
 * Handles interactions shared across the Today at Elon frontend.
 */

import jQuery from 'jquery';
import './modules/bootstrap.js';

function sanitizeHTML(str) {
	return str.toString().replace(/(<([^>]+)>)/gi, '');
}

jQuery(function($) {
	// Initialize Bootstrap tooltips.
	$('[data-toggle="tooltip"]').tooltip();

	// Submit header and global navigation searches.
	$('#searchArea, #globalNavSearchArea').on('submit', function(e) {
		e.preventDefault();

		var currentLocation = window.location.href;
		var whichSearch = $(this).attr('data-which');
		var searchInput = sanitizeHTML($('.' + whichSearch + '--search-input').val());

		$('.' + whichSearch + '--search-input').val(searchInput);
		window.data = sanitizeHTML($(this).serialize());

		if (
			currentLocation.includes(elon_news_global_data.site_search_url) &&
			typeof window.performSearch === 'function'
		) {
			window.performSearch(window.data);
		} else {
			window.location.href = elon_news_global_data.site_search_url + '?' + window.data;
		}
	});
	
	// Handle This Week at Elon email subscriptions.
	$('#mailchimp-signup').on('submit', function(e) {
		e.preventDefault();

		var msg;
		var err;
		var isError = false;
		var subscribeEmail;

		$('#mailchimp-error').hide();
		$('#mailchimp-message').hide();
		$('#mailchimp-signup').hide();
		$('#mailchimp-loader').show();

		subscribeEmail = $('#thisWeekSubscribe').val();

		if (subscribeEmail) {
			$.ajax({
				url: elon_news_global_data.ajax_url,
				format: 'json',
				type: 'POST',
				data: {
					action: 'thisweek_subscribe',
					email: subscribeEmail,
				},
				success: function(response) {
					$('#mailchimp-loader').hide();

					var obj = JSON.parse(response);

					if (obj.status == 'subscribed') {
						isError = false;
						msg = elon_news_global_data.this_week_success;
					} else if (obj.status == 'elon_error') {
						isError = true;
						err = obj.message;
					} else if (obj.status >= 400) {
						isError = true;

						if (obj.title == 'Member Exists') {
							err = elon_news_global_data.this_week_already_subscribed;
						} else {
							err = elon_news_global_data.this_week_general_error;
						}
					} else {
						isError = true;
						msg = elon_news_global_data.this_week_general_error;
					}
				},
				error: function() {
					isError = true;
					err = elon_news_global_data.this_week_general_error;
				},
				complete: function() {
					$('#mailchimp-loader').hide();
					$('#mailchimp-signup').show();

					if (isError) {
						$('#mailchimp-message').hide();
						$('#mailchimp-error-text').html(err);
						$('#mailchimp-error').show();
					} else {
						$('#mailchimp-error').hide();
						$('#mailchimp-message-text').html(msg);
						$('#mailchimp-message').show();
					}
				},
			});
		} else {
			$('#mailchimp-message').hide();
			$('#mailchimp-error').text(elon_news_global_data.this_week_invalid_email).show();
			$('#mailchimp-signup').show();
		}
	});

	// Move sidebar widgets between responsive containers.
	var mobileNavBreakpoint = 1080;
	var $widgetContainerDesktop = $('#sidebarWidgetsDesktop');
	var $widgetContainerMobile = $('#sidebarWidgetsMobile');

	function moveSidebarWidgets() {
		var windowWidth = $(window).width();

		if (windowWidth >= mobileNavBreakpoint) {
			$widgetContainerMobile.contents().appendTo($widgetContainerDesktop);
		} else {
			$widgetContainerDesktop.contents().appendTo($widgetContainerMobile);
		}
	}

	$(window).on('resize', moveSidebarWidgets);

	moveSidebarWidgets();
});
